module.exports = __webpack_public_path__ + "static/media/store_water.dea91316.png";